export const MESSAGING_TEMPLATES_SET = 'MESSAGING_TEMPLATES_SET';
export const MESSAGING_TEMPLATES_CLEAR = 'MESSAGING_TEMPLATES_CLEAR';
export const MESSAGING_TEMPLATES_START_FETCHING = 'MESSAGING_TEMPLATES_START_FETCHING';
export const MESSAGING_TEMPLATES_STOP_FETCHING = 'MESSAGING_TEMPLATES_STOP_FETCHING';
export const MESSAGING_TEMPLATES_FETCHED = 'MESSAGING_TEMPLATES_FETCHED';
export const MESSAGING_TEMPLATES_SET_ERROR = 'MESSAGING_TEMPLATES_SET_ERROR';
export const MESSAGING_TEMPLATES_FETCH = 'MESSAGING_TEMPLATES_FETCH';
